// extracted by mini-css-extract-plugin
module.exports = {"leftSide":"SalesFunnel_leftSide__C99rG","text":"SalesFunnel_text__3p8t3","centerSide":"SalesFunnel_centerSide__3I9ms","rightSide":"SalesFunnel_rightSide__wFShi"};